import { useQuery } from "@tanstack/react-query";

export type DevToolsStatus = { enabled: boolean; mailCatcher: boolean };

/** Whether dev tools (mail catcher, job runs) are enabled — dev-env and previews. */
export function useDevToolsStatus() {
  return useQuery({
    queryKey: ["dev-tools-status"],
    queryFn: async (): Promise<DevToolsStatus> => {
      const res = await fetch("/api/dev/status");
      if (!res.ok) return { enabled: false, mailCatcher: false };
      return (await res.json().catch(() => ({
        enabled: false,
        mailCatcher: false,
      }))) as DevToolsStatus;
    },
    staleTime: Infinity,
  });
}
